module.exports = __webpack_public_path__ + "static/media/health-drop.075843d9.mp3";